var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 40.0001C31.0459 40.0001 40.0002 31.0458 40.0002 20.0001C40.0002 8.95443 31.0459 0.00012207 20.0002 0.00012207C8.95455 0.00012207 0.000244141 8.95443 0.000244141 20.0001C0.000244141 31.0458 8.95455 40.0001 20.0002 40.0001Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 20C40 8.9544 31.0456 3.05176e-05 20 3.05176e-05C16.0875 3.05176e-05 12.438 1.12464 9.35533 3.06651L13.7392 4.92909L7.82611 7.44144L13.7392 9.9537L7.82611 12.4659L13.7392 14.978L7.82611 17.4898L13.7392 20.0014L7.82611 22.5136L13.7392 25.0257L7.82611 27.5375L13.7392 30.0495L7.82611 32.5617L13.7392 35.0735L9.35728 36.935C12.4395 38.876 16.0883 40 20 40C31.0456 40 40 31.0457 40 20Z",
    fill: "#751A46"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_952"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQatar);
export default __webpack_public_path__ + "static/media/qatar.5155c462aa7a7259c944566f272d9d4f.svg";
export { ForwardRef as ReactComponent };